// extracted by mini-css-extract-plugin
export default {"backButton":"microbial_sex_loops_backButton__d8Frn","microbialSexLoops":"microbial_sex_loops_microbialSexLoops__lTBcd"};